// Indicatifs téléphoniques internationaux (ISO2 + dial code). Liste ciblée sur les marchés RADAR + international courant.
export const PHONE_COUNTRIES = [
  { iso: "FR", name: "France", dial: "+33", flag: "🇫🇷" },
  { iso: "BE", name: "Belgique", dial: "+32", flag: "🇧🇪" },
  { iso: "CH", name: "Suisse", dial: "+41", flag: "🇨🇭" },
  { iso: "LU", name: "Luxembourg", dial: "+352", flag: "🇱🇺" },
  { iso: "IT", name: "Italie", dial: "+39", flag: "🇮🇹" },
  { iso: "ES", name: "Espagne", dial: "+34", flag: "🇪🇸" },
  { iso: "PT", name: "Portugal", dial: "+351", flag: "🇵🇹" },
  { iso: "NL", name: "Pays-Bas", dial: "+31", flag: "🇳🇱" },
  { iso: "DE", name: "Allemagne", dial: "+49", flag: "🇩🇪" },
  { iso: "GB", name: "Royaume-Uni", dial: "+44", flag: "🇬🇧" },
  { iso: "IE", name: "Irlande", dial: "+353", flag: "🇮🇪" },
  { iso: "CA", name: "Canada", dial: "+1", flag: "🇨🇦" },
  { iso: "US", name: "États-Unis", dial: "+1", flag: "🇺🇸" },
  { iso: "MA", name: "Maroc", dial: "+212", flag: "🇲🇦" },
  { iso: "DZ", name: "Algérie", dial: "+213", flag: "🇩🇿" },
  { iso: "TN", name: "Tunisie", dial: "+216", flag: "🇹🇳" },
  { iso: "AE", name: "Émirats arabes unis", dial: "+971", flag: "🇦🇪" },
  { iso: "SN", name: "Sénégal", dial: "+221", flag: "🇸🇳" },
  { iso: "CI", name: "Côte d'Ivoire", dial: "+225", flag: "🇨🇮" },
];

export const DEFAULT_PHONE_COUNTRY = "FR";

export const dialForIso = (iso) => (PHONE_COUNTRIES.find((c) => c.iso === iso) || {}).dial || "";
